@if(loader){
<app-loader></app-loader>
}
<div class="">

    <div class="flex mb-1 justify-content-between">
        <div>
            <p-button label="Add" icon="pi pi-user-plus" size="small" (click)="showContact()" size="small"></p-button>
            <p-button *ngIf="selectedContact.length == 1" label="Edit" class="ml-2" icon="pi pi-user-edit"
                (click)="editContact()" size="small" severity="secondary"></p-button>
            <p-button *ngIf="selectedContact && selectedContact.length > 0" label="Delete" class="ml-2"
                icon="pi pi-trash" (click)="deleteContact()" size="small" severity="danger"></p-button>
        </div>
        <div class="fixed-search-container flex align-items-center justify-content-center flex-grow-1">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
                    placeholder="Search keyword" class=" p-inputtext-sm" />
            </span>
        </div>
    </div>
    <p-table #dt1 [value]="result.contacts" [scrollable]="true" scrollHeight="350px" styleClass="p-datatable-striped"
        class="w-full m-5" styleClass="p-datatable-sm" [selectionPageOnly]="true" (onPage)="loadContacts($event)"
        [(selection)]="selectedContact"
        [globalFilterFields]="['contactName', 'type', 'mobile','email','address.city','address.country']">
        <ng-template pTemplate="header">
            <tr>
                <th>
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>City</th>
                <th>Country</th>
                <th>Type</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer>
            <tr>
                <td>
                    <p-tableCheckbox [value]="customer"></p-tableCheckbox>
                </td>
                <td>{{customer.contactName}}</td>
                <td>{{customer.mobile}}</td>
                <td>{{customer.email}}</td>
                <td>{{customer.address?.city}}</td>
                <td>{{customer.address?.country}}</td>
                <td>{{customer.type}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8">No Records found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-confirmDialog></p-confirmDialog>